export const getTimezoneOffsetHours = () =>
  -new Date().getTimezoneOffset() / 60;

export const getBrowserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch (e) {
    return undefined;
  }
};

export const browserTimeParams = () => ({
  timezone: getBrowserTimezone(),
  timezone_offset: getTimezoneOffsetHours(),
});
